var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M727.5,473.16c0,.14-157.83.26-352.48.26S22.5,473.3,22.5,473.16s157.8-.26,352.52-.26S727.5,473,727.5,473.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.49,405c-15-8.12-31.88-22.88-38.44-39.65C59.28,373.76,73,387.86,81.49,405",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.51,379.88c-15-8.11-31.88-22.88-38.44-39.65C58.3,348.6,72,362.7,80.51,379.88",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.27,355.29c-15-8.11-31.88-22.88-38.44-39.65,16.22,8.37,29.9,22.47,38.44,39.65",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,329.46c-13.93-10.15-28.91-27.15-33.43-44.7,15.1,10.57,27,26.47,33.43,44.7",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.75,309.53c-9.42-15.08-17.46-36.94-15.62-55.06a99.15,99.15,0,0,1,15.62,55.06",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.89,319c4-18.8,13.62-42,27.52-55.07A116.62,116.62,0,0,1,72.89,319",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,340.28c5.68-19.23,17.64-42.56,33.19-55a121,121,0,0,1-33.19,55",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.39,366.19c5.68-19.24,17.64-42.56,33.19-55a121.13,121.13,0,0,1-33.19,55",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.11,397.76c5.68-19.24,17.64-42.56,33.19-55a121.13,121.13,0,0,1-33.19,55",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.38,305.73a1.56,1.56,0,0,1,.09.31q.09.36.21.9c.19.85.44,2,.77,3.5.66,3,1.53,7.44,2.51,12.91s2,12,3.07,19.26,2,15.29,2.74,23.73,1.28,16.5,1.63,23.83.48,13.95.49,19.51,0,10-.11,13.15c0,1.51-.08,2.7-.11,3.57,0,.38,0,.68,0,.93a1.2,1.2,0,0,1,0,.31,1.2,1.2,0,0,1,0-.31c0-.25,0-.55,0-.93v-3.58c0-3.1,0-7.59-.08-13.14s-.28-12.15-.63-19.48-.91-15.37-1.67-23.81-1.73-16.43-2.69-23.7-2-13.8-2.94-19.27-1.73-9.89-2.32-12.94c-.27-1.49-.49-2.66-.65-3.51l-.15-.92A1.27,1.27,0,0,1,70.38,305.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.49,405c-15-8.12-31.88-22.88-38.44-39.65C59.28,373.76,73,387.86,81.49,405"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.51,379.88c-15-8.11-31.88-22.88-38.44-39.65C58.3,348.6,72,362.7,80.51,379.88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.27,355.29c-15-8.11-31.88-22.88-38.44-39.65,16.22,8.37,29.9,22.47,38.44,39.65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75,329.46c-13.93-10.15-28.91-27.15-33.43-44.7,15.1,10.57,27,26.47,33.43,44.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.75,309.53c-9.42-15.08-17.46-36.94-15.62-55.06a99.15,99.15,0,0,1,15.62,55.06"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.89,319c4-18.8,13.62-42,27.52-55.07A116.62,116.62,0,0,1,72.89,319"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76,340.28c5.68-19.23,17.64-42.56,33.19-55a121,121,0,0,1-33.19,55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.39,366.19c5.68-19.24,17.64-42.56,33.19-55a121.13,121.13,0,0,1-33.19,55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.11,397.76c5.68-19.24,17.64-42.56,33.19-55a121.13,121.13,0,0,1-33.19,55"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M88.08,411.53c-7-14.63-12.07-35.2-8.64-51.25a90.86,90.86,0,0,1,8.64,51.25",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,392.59c-7-14.63-12.07-35.2-8.64-51.26a90.91,90.91,0,0,1,8.64,51.26",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.12,373.33c-7-14.63-12.07-35.2-8.64-51.26a90.88,90.88,0,0,1,8.64,51.26",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39,352.55c-5.2-15.48-7.8-36.59-2.5-52a91.39,91.39,0,0,1,2.5,52",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.07,335.54c.51-16.47,5.36-37.11,15.59-49.27a89.31,89.31,0,0,1-15.59,49.27",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,343.71c12.12-11.43,30.54-22.79,47.1-24.27A91.23,91.23,0,0,1,124,343.71",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,361c13.58-10.76,33.75-20.86,51.19-20.9A95,95,0,0,1,115.81,361",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,381.94c13.58-10.76,33.75-20.86,51.19-20.9a95,95,0,0,1-51.19,20.9",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.37,406c13.58-10.76,33.76-20.86,51.2-20.9A95.07,95.07,0,0,1,91.37,406",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.66,332.55a1.07,1.07,0,0,1-.08.28c-.08.2-.17.46-.28.77l-1.14,3c-1,2.57-2.5,6.26-4.44,10.79-3.88,9.06-9.62,21.41-16.75,34.65-3.58,6.62-7.16,12.82-10.52,18.41S88.93,410.93,86.2,415s-5,7.39-6.6,9.63l-1.85,2.57-.5.66a1.36,1.36,0,0,1-.18.21s0-.09.13-.25l.45-.69c.43-.65,1-1.53,1.76-2.64,1.55-2.27,3.75-5.59,6.42-9.72s5.79-9.11,9.14-14.68,6.88-11.8,10.46-18.41c7.12-13.22,12.92-25.53,16.89-34.53,2-4.5,3.56-8.16,4.62-10.71l1.24-2.91.34-.76A1,1,0,0,1,128.66,332.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.99 473.16 65.08 473.16 57.09 414.03 116.21 414.03 107.99 473.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.11,422.69c0,.15-12.41.26-27.72.26s-27.73-.11-27.73-.26,12.42-.26,27.73-.26S114.11,422.55,114.11,422.69Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-109"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.86,
    y: 45.11,
    width: 298.27,
    height: 428.05,
    rx: 11.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.13,
    y: 75.65,
    width: 279.46,
    height: 357.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,451.65A11.44,11.44,0,1,1,375,440.2,11.44,11.44,0,0,1,386.44,451.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.08,
    y: 57.44,
    width: 89.84,
    height: 4.73,
    rx: 1.22,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.24,
    y: 133.11,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.44,
    y: 157.62,
    width: 29.4,
    height: 15.68,
    rx: 2.54,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.03,
    y: 164.42,
    width: 42.34,
    height: 15.04,
    rx: 1.04,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,164.42a32.08,32.08,0,0,1,.31,5.23v.3h-.31c-3.6.09-8.85.15-14.7.15s-11.1-.06-14.7-.15h-.31v-.3a32.08,32.08,0,0,1,.31-5.23,30.72,30.72,0,0,1,.31,5.23l-.31-.31c3.6-.09,8.85-.15,14.7-.15s11.1.06,14.7.15l-.31.31A30.72,30.72,0,0,1,306.84,164.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,179.33c-.26,0-.46-3.26-.46-7.28s.2-7.27.46-7.27.45,3.25.45,7.27S277.55,179.33,277.3,179.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.87,179.46c-.26,0-.46-3.14-.46-7s.2-7,.46-7,.45,3.14.45,7S307.12,179.46,306.87,179.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.61,
    y: 133.11,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.82,
    y: 157.62,
    width: 29.4,
    height: 15.68,
    rx: 2.54,
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.41,
    y: 164.42,
    width: 42.34,
    height: 15.04,
    rx: 1.04,
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.22,164.42a33,33,0,0,1,.3,5.23v.3h-.31c-3.6.09-8.86.15-14.7.15s-11.11-.06-14.7-.15h-.32v-.3a30.72,30.72,0,0,1,.31-5.23,30.72,30.72,0,0,1,.31,5.23l-.31-.31c3.59-.09,8.85-.15,14.7-.15s11.1.06,14.7.15l-.31.31A30.72,30.72,0,0,1,388.22,164.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.67,179.33c-.25,0-.46-3.26-.46-7.28s.21-7.27.46-7.27.46,3.25.46,7.27S358.93,179.33,358.67,179.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.24,179.46c-.25,0-.45-3.14-.45-7s.2-7,.45-7,.46,3.14.46,7S388.5,179.46,388.24,179.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.99,
    y: 133.11,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.2,
    y: 157.62,
    width: 29.4,
    height: 15.68,
    rx: 2.54,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.79,
    y: 164.42,
    width: 42.34,
    height: 15.04,
    rx: 1.04,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.59,164.42a30.72,30.72,0,0,1,.31,5.23v.3h-.32c-3.59.09-8.85.15-14.69.15s-11.11-.06-14.7-.15h-.32v-.3a30.72,30.72,0,0,1,.31-5.23,32.08,32.08,0,0,1,.31,5.23l-.31-.31c3.59-.09,8.85-.15,14.7-.15s11.1.06,14.69.15l-.31.31A32.08,32.08,0,0,1,469.59,164.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.05,179.33c-.25,0-.46-3.26-.46-7.28s.21-7.27.46-7.27.46,3.25.46,7.27S440.3,179.33,440.05,179.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.62,179.46c-.25,0-.46-3.14-.46-7s.21-7,.46-7,.46,3.14.46,7S469.88,179.46,469.62,179.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.24,
    y: 223.61,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.2,258.32,280.55,270l23,.09,3.67-11.18a9.89,9.89,0,0,0-3.95-.46L302.87,246a1.7,1.7,0,0,0-2.38-1.52l-2.24,1-13,0-1.49-.75a1.68,1.68,0,0,0-2.44,1.51l0,12.29A9.86,9.86,0,0,0,277.2,258.32Z",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.5,
    y: 270.01,
    width: 1.21,
    height: 10.63,
    transform: "translate(1.16 -1.18) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.78,
    y: 270.03,
    width: 1.21,
    height: 5.43,
    transform: "translate(1.13 -1.17) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.96,
    y: 270.08,
    width: 1.21,
    height: 5.43,
    transform: "translate(1.13 -1.22) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.32,
    y: 270.1,
    width: 1.21,
    height: 10.63,
    transform: "translate(1.16 -1.27) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263.27c-.09,0-.15-4-.13-8.89s.12-8.89.21-8.89.15,4,.13,8.89S285.51,263.27,285.42,263.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4,263.33c-.09,0-.15-4-.13-8.89s.12-8.89.21-8.89.15,4,.13,8.89S298.5,263.33,298.4,263.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,258.46a2.88,2.88,0,0,1-.59.18l-.33.08-.37.14-.44.16-.46.25a4.79,4.79,0,0,0-1.82,1.84,5.75,5.75,0,0,0-.64,3.24v.17h-6.3l-6.89-.05h-.14v-.14a6.33,6.33,0,0,0-.8-3A6.7,6.7,0,0,0,283,259.5a9.13,9.13,0,0,0-1.79-1.13,2.57,2.57,0,0,1,.54.18,5.89,5.89,0,0,1,1.36.82,6.66,6.66,0,0,1,1.61,1.87,6.33,6.33,0,0,1,.88,3.07l-.15-.14h6.89l6.14,0-.15.17A6,6,0,0,1,299,261a4.87,4.87,0,0,1,2-1.87l.48-.23.45-.15.39-.13.33-.06A3.53,3.53,0,0,1,303.25,258.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.17,264.39c0,.05-.43.13-1.07.42a5.54,5.54,0,0,0-2.1,1.66,5.67,5.67,0,0,0-1,2.48,10.75,10.75,0,0,1-.12,1.14,2.43,2.43,0,0,1-.11-1.17,5.16,5.16,0,0,1,1-2.65,5.1,5.1,0,0,1,2.29-1.68A2.3,2.3,0,0,1,285.17,264.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,270.35c-.05,0-.06-.49-.25-1.25a6.53,6.53,0,0,0-1.36-2.66,6.62,6.62,0,0,0-2.41-1.75c-.72-.3-1.2-.38-1.19-.43a2.67,2.67,0,0,1,1.27.22,5.9,5.9,0,0,1,3.92,4.57A2.69,2.69,0,0,1,303.3,270.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.61,
    y: 223.61,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.99,
    y: 223.61,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.24,
    y: 314.11,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.61,
    y: 314.11,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.99,
    y: 314.11,
    width: 71.93,
    height: 71.93,
    rx: 4.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.59,
    cy: 407.2,
    r: 2.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.58,407.2a2.58,2.58,0,1,1-2.58-2.59A2.58,2.58,0,0,1,377.58,407.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,407.2a2.59,2.59,0,1,1-2.58-2.59A2.59,2.59,0,0,1,388,407.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.75,105.6H259.59a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h13.16a.5.5,0,0,1,.5.5A.5.5,0,0,1,272.75,105.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.7,109.81a.52.52,0,0,1-.29-.09l-5.91-4.21a.49.49,0,0,1-.22-.41.55.55,0,0,1,.22-.41l6.09-4.15a.5.5,0,1,1,.56.82l-5.49,3.75L265,108.9a.5.5,0,0,1-.29.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.31,105.65H472.15a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h13.16a.5.5,0,0,1,.5.5A.5.5,0,0,1,485.31,105.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,109.81a.52.52,0,0,1-.42-.22.51.51,0,0,1,.13-.69l5.5-3.76-5.33-3.78a.51.51,0,0,1-.12-.7.5.5,0,0,1,.7-.12l5.91,4.21a.45.45,0,0,1,.21.41.52.52,0,0,1-.21.41l-6.09,4.15A.51.51,0,0,1,480,109.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 342.73,
    width: 29.67,
    height: 19.82,
    rx: 2.39,
    transform: "translate(-0.59 0.49) rotate(-0.1)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.89,346.38a1.83,1.83,0,0,1,0-.38q0-.44.06-1.08a24.28,24.28,0,0,0,0-4,8.93,8.93,0,0,0-2.27-5.24,5.89,5.89,0,0,0-2.93-1.63,16.42,16.42,0,0,0-3.69-.31c-2.52,0-5,.52-6.72,1.92a6.5,6.5,0,0,0-1.84,2.45,9.29,9.29,0,0,0-.69,2.61,19.77,19.77,0,0,0,0,4q.06.66.09,1.08c0,.25,0,.38,0,.38a1.54,1.54,0,0,1-.08-.37c0-.24-.09-.61-.15-1.07a18,18,0,0,1-.12-4,9.56,9.56,0,0,1,.68-2.7,6.66,6.66,0,0,1,1.89-2.58,8.28,8.28,0,0,1,3.17-1.57,15.55,15.55,0,0,1,3.76-.45,16.75,16.75,0,0,1,3.77.32,6.17,6.17,0,0,1,3.08,1.74,9.08,9.08,0,0,1,2.29,5.44,20.57,20.57,0,0,1-.08,4c0,.47-.09.83-.12,1.07A2.41,2.41,0,0,1,300.89,346.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.55,
    y: 342.63,
    width: 29.67,
    height: 19.82,
    rx: 2.39,
    transform: "translate(-0.59 0.49) rotate(-0.1)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85,362.43a3.18,3.18,0,0,0,.93-.23,2.28,2.28,0,0,0,.89-.7,2.31,2.31,0,0,0,.5-1.44c0-2.42,0-5.89-.07-10.17,0-1.07,0-2.2,0-3.37,0-.58,0-1.2,0-1.77a2.26,2.26,0,0,0-.82-1.5,2.39,2.39,0,0,0-1.72-.49h-2l-4.15,0-18.46,0a2.22,2.22,0,0,0-1.89,1.07,2.09,2.09,0,0,0-.32,1.06c0,.4,0,.79,0,1.19,0,1.6,0,3.17,0,4.71v8.91a3,3,0,0,0,.11,1,2.38,2.38,0,0,0,.48.83,2.22,2.22,0,0,0,1.71.73H289l10.16,0,2.77,0h.72l.24,0-.24,0-.72,0-2.76,0-10.17.08-7,0H278a2.54,2.54,0,0,1-1.95-.82,2.45,2.45,0,0,1-.55-.95,3.16,3.16,0,0,1-.13-1.09c0-2.84,0-5.82,0-8.91,0-1.54,0-3.11,0-4.71,0-.4,0-.79,0-1.21a2.49,2.49,0,0,1,.37-1.22,2.57,2.57,0,0,1,2.19-1.23l18.46,0h6.13a2.66,2.66,0,0,1,1.9.57,2.49,2.49,0,0,1,.91,1.69c0,.63,0,1.21,0,1.8,0,1.17,0,2.3,0,3.37,0,4.28,0,7.75,0,10.17a2.46,2.46,0,0,1-.55,1.51,2.42,2.42,0,0,1-.95.7A1.89,1.89,0,0,1,302.85,362.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.02,
    y: 342.73,
    width: 29.67,
    height: 19.82,
    rx: 2.39,
    transform: "translate(-0.59 0.63) rotate(-0.1)",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.61,346.38a1.83,1.83,0,0,1,0-.38q0-.44.06-1.08a24.28,24.28,0,0,0,0-4,8.93,8.93,0,0,0-2.27-5.24,5.89,5.89,0,0,0-2.93-1.63,16.42,16.42,0,0,0-3.69-.31c-2.52,0-5,.52-6.72,1.92a6.5,6.5,0,0,0-1.84,2.45,9.29,9.29,0,0,0-.69,2.61,19.77,19.77,0,0,0,0,4q.06.66.09,1.08c0,.25,0,.38,0,.38a1.54,1.54,0,0,1-.08-.37c0-.24-.09-.61-.15-1.07a18,18,0,0,1-.12-4,9.56,9.56,0,0,1,.68-2.7,6.66,6.66,0,0,1,1.89-2.58,8.28,8.28,0,0,1,3.17-1.57,15.55,15.55,0,0,1,3.76-.45,16.75,16.75,0,0,1,3.77.32,6.17,6.17,0,0,1,3.08,1.74,9.08,9.08,0,0,1,2.29,5.44,20.57,20.57,0,0,1-.08,4c0,.47-.09.83-.12,1.07A1.49,1.49,0,0,1,381.61,346.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.27,
    y: 342.63,
    width: 29.67,
    height: 19.82,
    rx: 2.39,
    transform: "translate(-0.59 0.63) rotate(-0.1)",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.57,362.43a3.18,3.18,0,0,0,.93-.23,2.28,2.28,0,0,0,.89-.7,2.31,2.31,0,0,0,.5-1.44c0-2.42,0-5.89-.07-10.17,0-1.07,0-2.2,0-3.37,0-.58,0-1.2,0-1.77a2.26,2.26,0,0,0-.82-1.5,2.39,2.39,0,0,0-1.72-.49h-2l-4.15,0-18.46,0a2.22,2.22,0,0,0-1.89,1.07,2.09,2.09,0,0,0-.32,1.06c0,.4,0,.79,0,1.19,0,1.6,0,3.17,0,4.71v8.91a3,3,0,0,0,.11,1,2.38,2.38,0,0,0,.48.83,2.23,2.23,0,0,0,1.72.73h10.93l10.17,0,2.76,0h.72l.24,0-.24,0-.72,0-2.76,0-10.17.08-7,0h-3.91a2.54,2.54,0,0,1-1.95-.82,2.45,2.45,0,0,1-.55-.95,3.15,3.15,0,0,1-.12-1.09c0-2.84,0-5.82,0-8.91,0-1.54,0-3.11,0-4.71,0-.4,0-.79,0-1.21a2.49,2.49,0,0,1,.37-1.22,2.57,2.57,0,0,1,2.19-1.23l18.46,0h6.13a2.66,2.66,0,0,1,1.9.57,2.54,2.54,0,0,1,.92,1.69c0,.63,0,1.21,0,1.8,0,1.17,0,2.3,0,3.37,0,4.28,0,7.75,0,10.17a2.41,2.41,0,0,1-1.5,2.21A1.89,1.89,0,0,1,383.57,362.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.94,
    y: 342.73,
    width: 29.67,
    height: 19.82,
    rx: 2.39,
    transform: "translate(-0.59 0.77) rotate(-0.1)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.53,346.38a1.83,1.83,0,0,1,0-.38q0-.44.06-1.08a24.28,24.28,0,0,0,0-4,9,9,0,0,0-2.27-5.24,5.89,5.89,0,0,0-2.93-1.63,16.47,16.47,0,0,0-3.69-.31c-2.53,0-5,.52-6.73,1.92a6.58,6.58,0,0,0-1.83,2.45,9.29,9.29,0,0,0-.69,2.61,19.77,19.77,0,0,0,0,4q.06.66.09,1.08a1.56,1.56,0,0,1,0,.38,1.54,1.54,0,0,1-.08-.37c0-.24-.09-.61-.15-1.07a18,18,0,0,1-.12-4,9.23,9.23,0,0,1,.68-2.7,6.56,6.56,0,0,1,1.89-2.58,8.28,8.28,0,0,1,3.17-1.57,15.43,15.43,0,0,1,3.76-.45,16.75,16.75,0,0,1,3.77.32,6.21,6.21,0,0,1,3.08,1.74,9,9,0,0,1,2.28,5.44,19.93,19.93,0,0,1-.07,4c0,.47-.09.83-.12,1.07A2.41,2.41,0,0,1,465.53,346.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.19,
    y: 342.63,
    width: 29.67,
    height: 19.82,
    rx: 2.39,
    transform: "translate(-0.59 0.77) rotate(-0.1)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.49,362.43a3.18,3.18,0,0,0,.93-.23,2.28,2.28,0,0,0,.89-.7,2.31,2.31,0,0,0,.5-1.44c0-2.42,0-5.89-.07-10.17,0-1.07,0-2.2,0-3.37,0-.58,0-1.2,0-1.77a2.24,2.24,0,0,0-.83-1.5,2.35,2.35,0,0,0-1.71-.49h-2l-4.15,0-18.46,0a2.22,2.22,0,0,0-1.89,1.07,2.09,2.09,0,0,0-.32,1.06c0,.4,0,.79,0,1.19,0,1.6,0,3.17,0,4.71v8.91a3,3,0,0,0,.11,1,2.23,2.23,0,0,0,.48.83,2.21,2.21,0,0,0,1.71.73H453.6l10.16,0,2.77,0h.72l.24,0-.24,0-.72,0-2.77,0-10.16.08-7,0h-3.92a2.53,2.53,0,0,1-1.94-.82,2.6,2.6,0,0,1-.56-.95,3.41,3.41,0,0,1-.12-1.09c0-2.84,0-5.82,0-8.91,0-1.54,0-3.11,0-4.71,0-.4,0-.79,0-1.21a2.49,2.49,0,0,1,.37-1.22,2.56,2.56,0,0,1,2.18-1.23l18.47,0h6.13a2.66,2.66,0,0,1,1.9.57,2.49,2.49,0,0,1,.91,1.69c0,.63,0,1.21,0,1.8,0,1.17,0,2.3,0,3.37,0,4.28,0,7.75,0,10.17a2.46,2.46,0,0,1-.55,1.51,2.42,2.42,0,0,1-.95.7A1.89,1.89,0,0,1,467.49,362.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,260.28,363.35,272l23,.1L390,260.88a9.77,9.77,0,0,0-3.95-.45L385.67,248a1.71,1.71,0,0,0-2.38-1.52l-2.24,1-13-.06-1.49-.75a1.68,1.68,0,0,0-2.44,1.51l0,12.3A9.71,9.71,0,0,0,360,260.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.3,
    y: 271.98,
    width: 1.21,
    height: 10.63,
    transform: "translate(1.17 -1.53) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.58,
    y: 271.99,
    width: 1.21,
    height: 5.43,
    transform: "translate(1.16 -1.55) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.76,
    y: 272.04,
    width: 1.21,
    height: 5.43,
    transform: "translate(1.14 -1.57) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.12,
    y: 272.07,
    width: 1.21,
    height: 10.63,
    transform: "translate(1.15 -1.59) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.22,265.24c-.09,0-.15-4-.13-8.89s.11-8.89.21-8.89.14,4,.12,8.89S368.31,265.24,368.22,265.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.2,265.29c-.09,0-.15-4-.13-8.89s.11-8.89.21-8.89.15,4,.12,8.89S381.29,265.29,381.2,265.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,260.43a5.06,5.06,0,0,1-.6.17l-.32.08-.38.15-.43.16-.46.25a4.69,4.69,0,0,0-1.82,1.83,5.78,5.78,0,0,0-.64,3.25v.16h-6.3l-6.89,0h-.14v-.14a6.24,6.24,0,0,0-.79-3,6.64,6.64,0,0,0-1.51-1.85,9.13,9.13,0,0,0-1.79-1.13,2.66,2.66,0,0,1,.53.17,6.07,6.07,0,0,1,1.37.82,6.71,6.71,0,0,1,1.61,1.88,6.44,6.44,0,0,1,.88,3.07l-.15-.15h6.89l6.14,0-.15.17a6,6,0,0,1,.72-3.4,4.85,4.85,0,0,1,1.95-1.87l.49-.24.45-.15.39-.12.33-.06A2.61,2.61,0,0,1,386.05,260.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,266.35c0,.06-.43.14-1.07.43a5.37,5.37,0,0,0-3.14,4.14,11.19,11.19,0,0,1-.12,1.14,2.5,2.5,0,0,1-.11-1.17,5,5,0,0,1,1-2.65,5.13,5.13,0,0,1,2.28-1.68A2.44,2.44,0,0,1,368,266.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.1,272.31c-.05,0-.06-.49-.25-1.24a6.47,6.47,0,0,0-1.36-2.66,6.57,6.57,0,0,0-2.42-1.75c-.71-.3-1.2-.39-1.19-.44a2.7,2.7,0,0,1,1.28.22,5.94,5.94,0,0,1,3.92,4.58A2.64,2.64,0,0,1,386.1,272.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.64,257.21,445,268.9l23,.1,3.67-11.19a9.89,9.89,0,0,0-3.95-.46l-.37-12.42a1.71,1.71,0,0,0-2.39-1.52l-2.24,1-12.95-.05-1.49-.75a1.68,1.68,0,0,0-2.45,1.51l0,12.29A9.86,9.86,0,0,0,441.64,257.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.94,
    y: 268.9,
    width: 1.21,
    height: 10.63,
    transform: "translate(1.16 -1.87) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.22,
    y: 268.92,
    width: 1.21,
    height: 5.43,
    transform: "translate(1.15 -1.89) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.4,
    y: 268.97,
    width: 1.21,
    height: 5.43,
    transform: "translate(1.15 -1.94) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.76,
    y: 268.99,
    width: 1.21,
    height: 10.63,
    transform: "translate(1.13 -1.92) rotate(0.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.86,262.16c-.09,0-.14-4-.12-8.89s.11-8.88.2-8.88.15,4,.13,8.89S450,262.16,449.86,262.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.85,262.22c-.1,0-.15-4-.13-8.89s.11-8.89.2-8.89.15,4,.13,8.89S462.94,262.22,462.85,262.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.69,257.35a2.62,2.62,0,0,1-.59.18l-.33.08-.37.14-.44.16-.46.25a4.79,4.79,0,0,0-1.82,1.84,5.76,5.76,0,0,0-.64,3.24l0,.17h-6.31l-6.89,0h-.14v-.14a6.22,6.22,0,0,0-.8-3,6.7,6.7,0,0,0-1.51-1.86,8.41,8.41,0,0,0-1.79-1.12,1.55,1.55,0,0,1,.54.17,5.89,5.89,0,0,1,1.36.82,6.8,6.8,0,0,1,1.61,1.87,6.4,6.4,0,0,1,.88,3.07l-.15-.14h6.89l6.14,0-.15.17a5.94,5.94,0,0,1,.73-3.41,4.7,4.7,0,0,1,1.95-1.86l.48-.24.45-.15.39-.12.34-.06A4.61,4.61,0,0,1,467.69,257.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.61,263.28c0,.05-.43.13-1.06.42a5.36,5.36,0,0,0-3.14,4.14c-.11.69-.07,1.14-.12,1.14a2.19,2.19,0,0,1-.12-1.16,5.1,5.1,0,0,1,1-2.66,4.93,4.93,0,0,1,2.28-1.67A2.25,2.25,0,0,1,449.61,263.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.74,269.24c-.05,0-.06-.49-.25-1.25a6.35,6.35,0,0,0-3.77-4.4c-.72-.31-1.2-.39-1.19-.44a2.67,2.67,0,0,1,1.27.22,5.94,5.94,0,0,1,2.59,1.75,6,6,0,0,1,1.33,2.82A2.69,2.69,0,0,1,467.74,269.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,104.53a3.94,3.94,0,0,1,4.19-4,4,4,0,0,1,3.27,1.44l-1.37,1.24a2.24,2.24,0,0,0-1.79-.89,2.18,2.18,0,0,0,0,4.35,2.27,2.27,0,0,0,1.79-.89l1.37,1.24a4,4,0,0,1-3.27,1.43A3.94,3.94,0,0,1,340,104.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.42,106.86H350.2l-.6,1.48h-2.2l3.37-7.62h2.12l3.37,7.62H354Zm-.63-1.59-1-2.43-1,2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.11,102.43h-2.34v-1.71h6.82v1.71h-2.33v5.91h-2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.12,106.86H364.9l-.6,1.48h-2.2l3.36-7.62h2.12l3.38,7.62h-2.24Zm-.63-1.59-1-2.43-1,2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.57,100.72h2.15v5.91h3.63v1.71h-5.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.69,104.53a4.24,4.24,0,1,1,4.23,4A4,4,0,0,1,377.69,104.53Zm6.29,0a2.06,2.06,0,1,0-2.06,2.18A2,2,0,0,0,384,104.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.39,104.37h1.9v3.15a5.61,5.61,0,0,1-3.2,1,4,4,0,1,1,.05-7.92,4.18,4.18,0,0,1,3.33,1.39l-1.37,1.24a2.41,2.41,0,0,0-1.85-.84,2.18,2.18,0,0,0,0,4.35,2.8,2.8,0,0,0,1.17-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.6,105v-4.23h2.15v4.16c0,1.31.54,1.83,1.45,1.83s1.43-.52,1.43-1.83v-4.16h2.13V105a3.58,3.58,0,0,1-7.16,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.33,106.68v1.66h-6.12v-7.62h6v1.67h-3.85v1.28h3.39v1.61h-3.39v1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.2,114.33c0,.14-18.35.26-41,.26s-41-.12-41-.26,18.35-.26,41-.26S416.2,114.18,416.2,114.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.67,117.65c0,.14-6,.26-13.46.26s-13.46-.12-13.46-.26,6-.26,13.46-.26S388.67,117.5,388.67,117.65Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.88,435l1.2,37.6,46.86-.79c-.35-4.47-26.69-12.86-26.69-12.86l-.19-25.28Z",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.88,435l1.2,37.6,46.86-.79c-.35-4.47-26.69-12.86-26.69-12.86l-.19-25.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.66,457a1.9,1.9,0,0,0-1.28,2.2,1.85,1.85,0,0,0,2.18,1.3,2,2,0,0,0,1.34-2.35,1.9,1.9,0,0,0-2.41-1.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.08,472.57l-.12-3.8,45.09.66s2.1.88,1.89,2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,459.33c0,.23-1.15.36-2.26,1.11s-1.69,1.73-1.91,1.64.11-1.41,1.47-2.3S158,459.12,158,459.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.14,461.36c.05.22-.93.63-1.69,1.61s-1,2-1.2,2-.39-1.3.58-2.5S164.13,461.14,164.14,461.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.93,467c-.21.06-.55-1.08,0-2.35s1.62-1.78,1.72-1.59-.55.87-1,1.92S167.15,467,166.93,467Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.49,453.06c-.1.21-1.15-.08-2.44,0s-2.3.54-2.42.35.83-1,2.36-1.14S157.59,452.88,157.49,453.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.22,447.42a4.38,4.38,0,0,1-2.35,0,10.48,10.48,0,0,1-2.47-.71,12.45,12.45,0,0,1-1.36-.69,3.45,3.45,0,0,1-.72-.54,1,1,0,0,1-.12-1.22,1.24,1.24,0,0,1,1-.54,2.86,2.86,0,0,1,.88.11,7.91,7.91,0,0,1,1.47.47,8.26,8.26,0,0,1,2.19,1.39c1.11,1,1.49,1.83,1.41,1.88s-.64-.63-1.76-1.44a8.71,8.71,0,0,0-3.47-1.54c-.5-.12-.92-.12-1,.1s-.05.12,0,.27a2.43,2.43,0,0,0,.53.39,14.25,14.25,0,0,0,1.25.69,13.49,13.49,0,0,0,2.29.83A16.94,16.94,0,0,1,158.22,447.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.44,121a17.44,17.44,0,0,0-16.76-16.7l-.91,0c-9.75.2-15,8.6-14.57,18.34l-.68,41.71c8.16,5.33,16,9.3,22.44,6.78l1-17.35s9.42-1.1,9.89-10.45C183.09,138.73,182.8,129.39,182.44,121Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,153.69a21.81,21.81,0,0,1-12.06-3.93s2.54,6.91,11.91,6.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.69,127.92a1.34,1.34,0,0,1-1.34,1.3A1.28,1.28,0,0,1,177,128a1.33,1.33,0,0,1,1.34-1.3A1.27,1.27,0,0,1,179.69,127.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.26,125.44c-.18.17-1.16-.62-2.6-.67s-2.52.63-2.67.45.11-.39.58-.71a3.64,3.64,0,0,1,2.15-.57,3.55,3.55,0,0,1,2.05.75C180.2,125.05,180.34,125.37,180.26,125.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.27,127.91a1.35,1.35,0,0,1-1.34,1.3A1.27,1.27,0,0,1,163.6,128a1.34,1.34,0,0,1,1.33-1.3A1.29,1.29,0,0,1,166.27,127.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,125.17c-.17.17-1.15-.62-2.59-.67s-2.52.63-2.67.45.11-.39.58-.71a3.63,3.63,0,0,1,2.14-.57,3.49,3.49,0,0,1,2.06.75C166.06,124.77,166.2,125.1,166.11,125.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.92,136a9.85,9.85,0,0,1,2.36-.33c.36,0,.71-.08.79-.33a2,2,0,0,0-.21-1.1c-.31-.9-.63-1.85-1-2.84-1.35-4-2.32-7.35-2.16-7.4s1.4,3.17,2.75,7.21l.94,2.85a2.15,2.15,0,0,1,.13,1.45.94.94,0,0,1-.62.52,3,3,0,0,1-.63.06A9.62,9.62,0,0,1,170.92,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55,121.87c.15-.39,1.58-.2,3.27-.4s3.06-.65,3.28-.3c.1.17-.14.53-.69.91a5.45,5.45,0,0,1-2.43.85,5.62,5.62,0,0,1-2.56-.31C159.8,122.37,159.49,122.06,159.55,121.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,120.45c-.32.31-1.53-.07-3-.14s-2.72.11-3-.24c-.12-.17.09-.49.65-.78a4.87,4.87,0,0,1,2.45-.44,4.67,4.67,0,0,1,2.37.75C180,120,180.15,120.3,180,120.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7,129.51c-.15-.08-6.35-2.15-6.39,4.26s6.39,5.12,6.41,4.93S150.7,129.51,150.7,129.51Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,136.27s-.12.07-.31.16a1.11,1.11,0,0,1-.83,0,2.76,2.76,0,0,1-1.26-2.48,3.72,3.72,0,0,1,.32-1.6,1.28,1.28,0,0,1,.85-.85.55.55,0,0,1,.65.31c.09.18.05.31.08.32s.14-.11.09-.37a.76.76,0,0,0-.25-.41.86.86,0,0,0-.62-.16,1.57,1.57,0,0,0-1.17,1,3.84,3.84,0,0,0-.4,1.79,2.9,2.9,0,0,0,1.61,2.77,1.19,1.19,0,0,0,1-.16C148.76,136.42,148.8,136.28,148.78,136.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.1,131.1a.17.17,0,0,1-.18-.15.16.16,0,0,1,.13-.19.15.15,0,0,1,.18.14A.16.16,0,0,1,161.1,131.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.87,130.58c-.08,0-.17-.06-.18-.17s0-.21.12-.22a.18.18,0,0,1,.19.17A.18.18,0,0,1,163.87,130.58Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73,130.61c-.09,0-.17-.1-.19-.25s.05-.26.14-.27.17.1.18.24S165.81,130.6,165.73,130.61Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.39,132.88c-.09,0-.16-.06-.16-.11s.08-.1.17-.1.15.05.15.11S162.48,132.88,162.39,132.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.93,132.39a.18.18,0,0,1-.17-.17.17.17,0,0,1,.15-.19.17.17,0,0,1,.17.17A.18.18,0,0,1,164.93,132.39Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,131.32a.17.17,0,0,1-.19-.15.17.17,0,0,1,.13-.2.18.18,0,0,1,.06.35Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,131.22a.17.17,0,0,1-.17-.19.19.19,0,0,1,.14-.21.18.18,0,0,1,.17.19C180.13,131.12,180.07,131.22,180,131.22Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.44,131.31a.15.15,0,0,1-.17-.12.14.14,0,0,1,.13-.16.15.15,0,0,1,.18.11A.16.16,0,0,1,176.44,131.31Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.76,133.23a.17.17,0,0,1-.21-.11.16.16,0,0,1,.08-.23.17.17,0,0,1,.21.11A.17.17,0,0,1,177.76,133.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.37,133a.13.13,0,1,1,.08-.25.13.13,0,0,1,.11.17A.14.14,0,0,1,179.37,133Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.05,141c-.07.13-1.23-.46-2.78-.73s-2.84-.14-2.86-.29a5.91,5.91,0,0,1,5.64,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,108.33a3.86,3.86,0,0,1-1.1-.53,2.41,2.41,0,0,1-.51-1.87,2,2,0,0,0-.69-1.78c-.79-.44-1.82.31-2.66,0s-.93-1.49-1.37-2.29a2.47,2.47,0,0,0-3.05-1c-.74.33-1.54,1.05-2.24.63s-.52-1.28-.79-1.94a1.74,1.74,0,0,0-2.41-.8c-.62.37-1.2,1.18-1.86.88s-.53-1.21-1.05-1.6a1.15,1.15,0,0,0-1.42.22,7.74,7.74,0,0,0-.93,1.26,1.6,1.6,0,0,1-1.29.76c-.57,0-1-.56-1.41-.93-1.49-1.26-3.83-1-5.44.12a9.37,9.37,0,0,0-2.49,2.75,10.85,10.85,0,0,0-5.22.13c-3.82,1.12-6.86,4.87-6.63,8.84.12,1.86.88,3.61,1.19,5.45a41.87,41.87,0,0,1,.11,6.63c0,2.21.14,4.24,1.59,5.91l1.91.49a4.71,4.71,0,0,0,.45.65,2,2,0,0,0,2.52.66,2.52,2.52,0,0,0,.8-1.45c1.17-4,2.34-8.32,1.8-12.4a5.48,5.48,0,0,1,2.69-5.59,8.61,8.61,0,0,1,1.92-.84,5.38,5.38,0,0,1,2,0,5.5,5.5,0,0,1,3.48,2.27c.57.82,1,1.89,2,2.14s2.05-.56,3.12-.56,2,.89,2.82,1.67,1.9,1.54,3,1.21,1.52-1.36,2.47-1.68a3,3,0,0,1,2.09.27,9.25,9.25,0,0,0,2,.79,1.84,1.84,0,0,0,1.92-.65c.43-.69.16-1.69.67-2.33s1.28-.59,2-.87a2.5,2.5,0,0,0,.06-4.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.91,120.25c0-.08.65,0,1.66-.14a9.1,9.1,0,0,0,6.56-3.9,15,15,0,0,1,.92-1.39,3.39,3.39,0,0,1-.61,1.59,8.23,8.23,0,0,1-6.85,4.07A3.42,3.42,0,0,1,146.91,120.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54,122.65a14.52,14.52,0,0,0,5-.75,14.82,14.82,0,0,0,4.17-2.81c.05,0-.23.56-.89,1.25a8.86,8.86,0,0,1-3.09,2A8.77,8.77,0,0,1,148,123,3.22,3.22,0,0,1,146.54,122.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.68 250.12 128.05 286.77 135.46 452.73 158.13 449.98 161.1 371.04 173.33 282.74 174.56 251.49 139.68 250.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.14,412.94l-22.21,30.38,37.41,28.22c2.48-3.74-13.11-26.57-13.11-26.57l15.41-20Z",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.53,435.67a1.91,1.91,0,0,0-2.37.95,1.84,1.84,0,0,0,.91,2.36,2,2,0,0,0,2.51-1,1.92,1.92,0,0,0-1.23-2.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.93,443.32l2.25-3.07,35.12,28.28s1.11,2,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,445.74c-.14.18-1.12-.43-2.46-.52s-2.4.32-2.51.12.95-1,2.58-.92S149.7,445.6,149.53,445.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.15,451.14c-.09.2-1.11-.08-2.32.22s-2,1-2.17.85.49-1.27,2-1.62S153.28,451,153.15,451.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9,457.28c-.2-.09.23-1.19,1.46-1.84s2.38-.4,2.34-.19-1,.35-2,.89S152.09,457.4,151.9,457.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,440.5c-.2.11-.85-.77-1.93-1.48S149,438,149,437.8s1.29-.3,2.56.56S153.22,440.43,153,440.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,436.51c0,.08-.86-.35-1.86-1.42A10.36,10.36,0,0,1,153.7,433a10.48,10.48,0,0,1-.65-1.39,3.32,3.32,0,0,1-.23-.86,1,1,0,0,1,.65-1,1.27,1.27,0,0,1,1.12.19,3,3,0,0,1,.62.62,9.05,9.05,0,0,1,.87,1.28,8.29,8.29,0,0,1,.87,2.44,4,4,0,0,1,0,2.35c-.13,0-.12-.89-.51-2.22a9,9,0,0,0-1-2.2,9.38,9.38,0,0,0-.82-1.15c-.32-.4-.66-.66-.89-.56s-.11.07-.12.25a2.47,2.47,0,0,0,.18.63,10.53,10.53,0,0,0,.56,1.31,12.81,12.81,0,0,0,1.29,2.07C156.48,435.83,157.15,436.42,157.07,436.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.56,251.49l13.16.52S217,356.72,214.05,365.9,156.91,436,156.91,436l-16.22-17s17.36-29.53,25.15-37.92c5.58-6,20-17.53,20-17.53l-18.53-37.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84,292.2a12.26,12.26,0,0,1-.56,1.65c-.39,1-.95,2.57-1.61,4.45-1.32,3.78-3,9.05-4.42,15s-2.33,11.39-2.86,15.36c-.27,2-.47,3.59-.59,4.7a12.42,12.42,0,0,1-.25,1.72,10,10,0,0,1,0-1.74c.06-1.12.2-2.73.42-4.73a130.45,130.45,0,0,1,2.72-15.43,131.85,131.85,0,0,1,4.58-15c.71-1.88,1.32-3.38,1.77-4.41A10.49,10.49,0,0,1,175.84,292.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.91,436l-.32-.29-.88-.88-3.33-3.41-11.85-12.31-.11-.11.09-.15c4.21-7.06,9.23-15.59,15.1-24.46a118.8,118.8,0,0,1,15.7-19.54,89.79,89.79,0,0,1,7.76-6.73c1.25-.92,2.42-1.8,3.54-2.59l3.16-2.14,0,0h.06l6.3,1.41,1.67.39a2.53,2.53,0,0,1,.57.16,4.17,4.17,0,0,1-.58-.09l-1.69-.31-6.33-1.27.11,0-3.12,2.18c-1.11.79-2.27,1.69-3.51,2.61a93.49,93.49,0,0,0-7.67,6.76,120.65,120.65,0,0,0-15.58,19.5c-5.87,8.85-10.91,17.36-15.17,24.4l0-.27,11.71,12.44,3.24,3.48.84.93A1.82,1.82,0,0,1,156.91,436Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.7,230.35c.05.27,4.76-1.41,5.27-3.26s.37-7.19.37-7.19l-12-7.26.06,10A9.93,9.93,0,0,1,190.7,230.35Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,152.12l5.31,3.39s1.66,4.11,3.78,6,5.77,5.71,5.77,5.71l1.61,5.78,11.59-2.95-5-16.75L199,148.87s-2.54-3.89-5.82-1.82c0,0,.41-1.45-1-1.54a16.69,16.69,0,0,0-3.45.36,5.56,5.56,0,0,0-2.93-1.05,11.65,11.65,0,0,0-2.23.23s-.39-1.65-1.27-1.44-2,1.78-2.31,2.71a12.09,12.09,0,0,0-.09,3.5Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.75,147a4.9,4.9,0,0,0-1.93,2,6,6,0,0,0-.63,2.92,11.55,11.55,0,0,0,.16,1.8c.05.31.1.63.16.95a4.24,4.24,0,0,0,.2.91.88.88,0,0,0,.62.43,1.56,1.56,0,0,0,.83,0,1.46,1.46,0,0,0,1.06-1.08c.28-1-.07-2.13.08-3.06a2.15,2.15,0,0,1,.49-1.18,1.67,1.67,0,0,1,.8-.54c.53-.15.81.08.79.09a2,2,0,0,0-.72.1,1.77,1.77,0,0,0-1,1.57c-.11.83.3,1.88,0,3.15a2,2,0,0,1-3.44.75,4.22,4.22,0,0,1-.24-1.05c-.06-.33-.11-.65-.16-1a12.09,12.09,0,0,1-.13-1.87,6.18,6.18,0,0,1,.78-3.1,4.17,4.17,0,0,1,1.51-1.54C193.45,147,193.74,147,193.75,147Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,153.23c0,.14-.64.2-1.4.24s-1.4.06-1.43-.08.59-.39,1.4-.44S197.68,153.09,197.67,153.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.29,155.6s.13.24.16.72a2.46,2.46,0,0,1-.68,1.93,1.94,1.94,0,0,1-1.38.57,1.82,1.82,0,0,1-1.47-.9,4.84,4.84,0,0,1-.61-1.72q-.17-.9-.27-1.86a25.44,25.44,0,0,1-.13-3.64,10.11,10.11,0,0,1,.43-3,3.18,3.18,0,0,1,1.22-1.63,1.25,1.25,0,0,1,.7-.26s-.23.13-.58.42a3.3,3.3,0,0,0-1,1.59,11.3,11.3,0,0,0-.3,2.86,29.93,29.93,0,0,0,.17,3.57,9.56,9.56,0,0,0,.77,3.39,1.37,1.37,0,0,0,1.08.72,1.62,1.62,0,0,0,1.11-.41,2.41,2.41,0,0,0,.73-1.66A3.78,3.78,0,0,1,191.29,155.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66,154.69c.11,0-.2,1-1.67,1.49a2,2,0,0,1-2-1.55,10.08,10.08,0,0,1-.36-3,13.92,13.92,0,0,1,1-5.34,2.42,2.42,0,0,1,1.18-1.21c.38-.16.61-.11.61-.08s-.21.07-.52.26a2.4,2.4,0,0,0-.93,1.18,16.27,16.27,0,0,0-.84,5.19,10.43,10.43,0,0,0,.29,2.84,1.73,1.73,0,0,0,1.46,1.35,3,3,0,0,0,1.34-.7C186.55,154.87,186.62,154.68,186.66,154.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.65,145.05a3.25,3.25,0,0,1-.07,1.29,5.71,5.71,0,0,1-1.13,3,1.62,1.62,0,0,1-.85.56,1.23,1.23,0,0,1-1-.18,1.75,1.75,0,0,1-.79-1.3,2,2,0,0,1,.17-1.31c.09,0,0,.52.19,1.24a1.46,1.46,0,0,0,.67,1,.9.9,0,0,0,1.19-.31,6.73,6.73,0,0,0,1.16-2.7C183.42,145.51,183.58,145,183.65,145.05Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.05,159.49a25.59,25.59,0,0,0-2.24-1.8,24.77,24.77,0,0,0-2.66-1.11,3.82,3.82,0,0,1,2.92.66A3.86,3.86,0,0,1,198.05,159.49Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.06,162.26a6.51,6.51,0,0,1-7,3,17.1,17.1,0,0,0,3.76-.88A16.9,16.9,0,0,0,200.06,162.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.77,142.7a11.24,11.24,0,0,1-5.63,9.45,24.07,24.07,0,0,0,3.6-4.25A24.59,24.59,0,0,0,182.77,142.7Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,173.84s3.43,1.58,5.12,6.53c1.15,3.38,7.65,15.2,7.65,15.2L193.87,173,205.34,169s9.69,21.09,12,34c2.31,12.65-4,21-10.73,20.76s-23-11.57-23-11.57Z",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,173a8,8,0,0,1,.26,1.33c.13,1,.31,2.19.52,3.66.41,3.09.95,7.37,1.51,12.09.21,1.84.42,3.61.61,5.24h0c.29,1.7.56,3.29.81,4.73a24.5,24.5,0,0,0,.93,3.64c.71,2,1.29,3.1,1.22,3.13a4.37,4.37,0,0,1-.47-.76,24.89,24.89,0,0,1-1-2.27,22.06,22.06,0,0,1-1.06-3.66c-.27-1.44-.56-3-.88-4.72h0c-.2-1.63-.42-3.4-.64-5.24-.56-4.72-1-9-1.36-12.11-.14-1.47-.26-2.7-.35-3.67A5.84,5.84,0,0,1,193.87,173Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M217.82,209.85c0-2.29-8,.55-11.09,2.64a19.88,19.88,0,0,0-6.94,9.12s5.47,3.15,9.67,1.72C215.42,221.31,217.75,213.78,217.82,209.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,158.9s-21.68,10.48-24,16.9,1.54,22.92,1.54,22.92l8.56,44.53,1.78,16.64-4.63,6.72,2,6.9c23.37,3.11,45.22,3.76,63.85-.85L194,257.32l-8.6-35.55-1.12-29.87-.52-18.06-11.65-9.55s-1.9,5.2-6.71,4.11-16.09-12.52-16.09-12.52Z",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.52,202.87c.66.68,14.34,37,24,41.48s15.35,2.92,19.55,1.77S190.64,232,190.64,232s-1.29-8.72-6.63-9a41.71,41.71,0,0,0-10.07.8l-6.48-4.29s-3.76-7.35-5.93-7.66l-12.59-28S137.23,161,125.59,171.55C114.26,181.8,124.52,202.87,124.52,202.87Z",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.19,167a4.62,4.62,0,0,1-.7,1.11A11.57,11.57,0,0,1,171,170.6a7.86,7.86,0,0,1-2.25,1.1,8.59,8.59,0,0,1-2.86.29,19.65,19.65,0,0,1-6.28-1.65A22,22,0,0,1,154,167a33.17,33.17,0,0,1-3.76-3.72c-1-1.13-1.73-2.09-2.23-2.76a5.64,5.64,0,0,1-.74-1.08,6.73,6.73,0,0,1,.89,1c.56.63,1.34,1.55,2.36,2.64a37.24,37.24,0,0,0,3.78,3.6,22.49,22.49,0,0,0,5.47,3.22,20.09,20.09,0,0,0,6.1,1.65,7.56,7.56,0,0,0,4.87-1.21,12.51,12.51,0,0,0,2.57-2.36A9.68,9.68,0,0,1,174.19,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,183.91c.14,0,.68,8.65,1.2,19.33s.83,19.34.68,19.35-.68-8.65-1.2-19.33S182.46,183.92,182.61,183.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5,172l.24-.11.74-.3a12.29,12.29,0,0,1,3-.71,11.32,11.32,0,0,1,5,.58,15.8,15.8,0,0,1,5.66,3.63,28.7,28.7,0,0,1,5,6.65c.75,1.32,1.35,2.79,2,4.26s1.36,3,2.07,4.59l9.53,21.11-.18-.13a4.2,4.2,0,0,1,2,1.45,20.71,20.71,0,0,1,1.5,2,46.74,46.74,0,0,1,2.58,4.36l-.05-.06,2.54,2.54-.16-.07,12.34.83,1.59.1a5.89,5.89,0,0,1,1.65.37,6.21,6.21,0,0,1,2.61,2.06,15.59,15.59,0,0,1,2.57,6.14c0,.22.09.44.12.65l0,.16-.13.09c-5.4,3.78-10.72,7.41-16,10.68-1.33.8-2.65,1.61-4,2.32-.33.19-.67.35-1,.52a10,10,0,0,1-1.06.46,18.56,18.56,0,0,1-2.19.63,23.34,23.34,0,0,1-8.77.61,30.08,30.08,0,0,1-8.06-2.28,15.37,15.37,0,0,1-1.84-.87,5.87,5.87,0,0,1-.85-.55,8,8,0,0,1-.78-.63,22.29,22.29,0,0,1-2.69-2.82,77.32,77.32,0,0,1-7.5-12c-4-7.65-6.72-14.08-8.61-18.51-.91-2.21-1.63-3.93-2.12-5.12s-.76-1.78-.76-1.78a10,10,0,0,1,.85,1.74l2.22,5.08c1.94,4.4,4.72,10.81,8.74,18.42A79.69,79.69,0,0,0,143.84,240a14,14,0,0,0,6,4.72,29.74,29.74,0,0,0,7.94,2.23,22.84,22.84,0,0,0,8.59-.62,17,17,0,0,0,2.14-.62,8.93,8.93,0,0,0,1-.45,10.62,10.62,0,0,0,1-.51c1.34-.7,2.65-1.5,4-2.31,5.27-3.26,10.59-6.89,16-10.66l-.11.25-.12-.63a15,15,0,0,0-2.47-5.92,5.78,5.78,0,0,0-2.39-1.9,10.57,10.57,0,0,0-3.08-.44L170,222.27h-.09l-.07-.07-2.53-2.54,0,0v0a48.83,48.83,0,0,0-2.54-4.31,20.58,20.58,0,0,0-1.46-1.92,3.9,3.9,0,0,0-1.74-1.3l-.14,0,0-.1-9.46-21.15-2.05-4.6c-.68-1.49-1.26-2.93-2-4.24a28.38,28.38,0,0,0-4.89-6.61,15.6,15.6,0,0,0-5.53-3.63,11.38,11.38,0,0,0-4.87-.64,13,13,0,0,0-3,.63l-.75.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.31,222.41c0,.31-2.73.2-6.05-.07L165,222a7.47,7.47,0,0,1-1.76-.23c0-.17,2.73-.2,6.06.08,1.67.13,3.18.29,4.27.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9,212.4a22.71,22.71,0,0,1,4.8-.59,23.11,23.11,0,0,1,4.84-.07,22.74,22.74,0,0,1-4.81.59A23,23,0,0,1,151.9,212.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.86,243.11a21.31,21.31,0,0,0-14.16-10.27c-6-1.16-13.13.86-18,4.58A20.52,20.52,0,0,0,156.41,247,24.21,24.21,0,0,0,173.86,243.11Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.52,160.78c1.66,4.12,4,8.09,7.5,10.84s8.28,4.11,12.5,2.74c2.18-.7,4.28-2.38,4.49-4.65a19.72,19.72,0,0,1-23.84-8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.33,212.64a78.76,78.76,0,0,0-.09-25.13c-.1-.58-.45-1.33-1-1.19s-.55.7-.57,1.16a204.05,204.05,0,0,0,1.22,25.44"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182.71,267.19a1.81,1.81,0,0,1-.49.17l-1.4.39c-.61.16-1.36.35-2.24.53s-1.88.43-3,.61c-2.22.41-4.9.77-7.88,1a90.16,90.16,0,0,1-9.74.23,91.66,91.66,0,0,1-9.7-.9c-3-.46-5.61-1-7.8-1.57-1.1-.25-2.08-.56-3-.81s-1.6-.48-2.2-.69l-1.37-.48a3.32,3.32,0,0,1-.47-.2,1.81,1.81,0,0,1,.5.1l1.4.39c.61.18,1.35.39,2.22.6s1.85.5,3,.73c2.19.52,4.83,1,7.78,1.46s6.21.72,9.65.85,6.71,0,9.68-.19,5.64-.54,7.86-.91c1.12-.15,2.12-.36,3-.52s1.64-.31,2.25-.45l1.43-.29A1.92,1.92,0,0,1,182.71,267.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138,266.29a5.17,5.17,0,0,1,4.12-2.06,17.67,17.67,0,0,1,4.72.65,71.53,71.53,0,0,0,32.7-.45,3.5,3.5,0,0,1-1.83,3.27,11,11,0,0,1-3.81,1.05c-12,2.25-24.42.79-36-2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-109"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 558.88,
    y: 265.67,
    width: 134.75,
    height: 96.88,
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,265.67c.19,0,0,20.46,0,20.46H585V265.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 626.25,
    y: 265.67,
    width: 67.38,
    height: 96.88,
    transform: "translate(1319.88 628.22) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 562.98,
    y: 343.58,
    width: 18.04,
    height: 12.77,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.05,356.37H563V343.56h18.09Zm-18-.05h18V343.61H563Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584.35,
    y: 343.58,
    width: 9.02,
    height: 12.77,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.4,356.37h-9.07V343.56h9.07Zm-9-.05h9V343.61h-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.33,
    y: 362.63,
    width: 153.29,
    height: 110.2,
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.45,362.63c.21,0,0,23.26,0,23.26H564.1V362.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 610.97,
    y: 362.63,
    width: 76.64,
    height: 110.2,
    transform: "translate(1298.59 835.45) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 539,
    y: 451.25,
    width: 20.52,
    height: 14.52,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.55,465.8H539V451.23h20.57ZM539,465.75H559.5V451.28H539Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.31,
    y: 451.25,
    width: 10.26,
    height: 14.52,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.6,465.8H563.29V451.23H573.6Zm-10.26-.05h10.21V451.28H563.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.63,362.55c0,.14-30.17.26-67.38.26s-67.37-.12-67.37-.26,30.16-.26,67.37-.26S693.63,362.41,693.63,362.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.39,74.55a1.22,1.22,0,0,1,.69,1.09v6a1.22,1.22,0,0,1-1.55,1.17,3.77,3.77,0,0,0-3,.45A3.38,3.38,0,0,0,91,85.47a3.47,3.47,0,0,0,.62,2.64,3.88,3.88,0,0,0,2.49,1.65,4.55,4.55,0,0,0,4.76-3.08,1.21,1.21,0,0,1,2.31.74,7,7,0,0,1-7.45,4.74,6.26,6.26,0,0,1-4.11-2.67,5.63,5.63,0,0,1,1.73-8.26,6.39,6.39,0,0,1,3.34-.93V75.64a1.21,1.21,0,0,1,1.21-1.21A1.18,1.18,0,0,1,96.39,74.55Z",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71,72a1,1,0,1,1,1,1A1,1,0,0,1,94.71,72Z",
    style: {
      fill: "#0967F4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.33,104.38s-.3,0-.79.25a3.72,3.72,0,0,0-1.69,1.44,3.44,3.44,0,0,0-.52,1.44,3.08,3.08,0,0,0,.3,1.71,3.57,3.57,0,0,0,3.26,2,3.54,3.54,0,0,0,3-2.36,3,3,0,0,0,.1-1.73,3.6,3.6,0,0,0-.68-1.37,3.75,3.75,0,0,0-1.85-1.24c-.51-.14-.82-.12-.82-.15a.57.57,0,0,1,.22,0,1.42,1.42,0,0,1,.27,0,1.81,1.81,0,0,1,.36,0,3.72,3.72,0,0,1,2,1.22,3.53,3.53,0,0,1,.75,1.44,3.3,3.3,0,0,1-.08,1.86,3.73,3.73,0,0,1-1.17,1.69,3.54,3.54,0,0,1-2,.85,3.6,3.6,0,0,1-2.12-.6,3.8,3.8,0,0,1-1.36-1.55,3.14,3.14,0,0,1-.3-1.83,3.48,3.48,0,0,1,.58-1.52,3.65,3.65,0,0,1,1.8-1.44,2.13,2.13,0,0,1,.35-.1.92.92,0,0,1,.26,0C124.26,104.37,124.33,104.37,124.33,104.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16,113.16s-.18,0-.49.17a2.35,2.35,0,0,0-1,.91,2,2,0,0,0-.12,2,2.06,2.06,0,0,0,3.85-.23A2,2,0,0,0,135,114a2.33,2.33,0,0,0-1.13-.78c-.33-.09-.52-.09-.52-.11a1,1,0,0,1,.54,0,2.31,2.31,0,0,1,1.26.77,2.26,2.26,0,0,1,.48.91,2,2,0,0,1,0,1.2,2.39,2.39,0,0,1-2.05,1.63,2.42,2.42,0,0,1-2.24-1.38,2.07,2.07,0,0,1-.19-1.18,2.27,2.27,0,0,1,.38-1,2.23,2.23,0,0,1,1.15-.9A1.09,1.09,0,0,1,133.16,113.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.87,86.38s0-.15,0-.45,0-.76,0-1.34c0-.29,0-.62,0-1s0-.76-.08-1.18-.07-.89-.11-1.38a5.11,5.11,0,0,0-.1-.76c-.05-.26-.1-.52-.15-.8A26.81,26.81,0,0,0,120,71.82a27.75,27.75,0,0,0-6.47-8.47l-1.13-1c-.4-.31-.83-.6-1.25-.91l-.64-.45a5,5,0,0,0-.66-.44l-1.39-.81-.71-.4L107,59l-1.52-.7c-.52-.22-1.07-.37-1.61-.57l-.82-.28-.41-.13-.43-.1a26.27,26.27,0,0,0-3.49-.68c-.6-.07-1.2-.18-1.81-.22l-1.85,0c-.31,0-.62,0-.94,0l-.94.07c-.62.06-1.26.08-1.89.16a29.88,29.88,0,0,0-3.8.8l-1,.27L86,57.7l-.46.18-1.87.73c-.61.27-1.21.6-1.81.9-.3.16-.62.29-.91.48l-.87.55A31.18,31.18,0,0,0,76.74,63L75.2,64.42l-.39.37-.35.4-.71.8-.7.81-.64.87-.63.88-.31.44c-.1.15-.19.31-.28.47l-1.1,1.89-.92,2A27.69,27.69,0,0,0,67.8,90.92L68.4,93c.26.69.53,1.36.79,2l.2.51.24.48.49,1,.49,1,.57.91.58.9.28.45.33.42,1.29,1.67a34,34,0,0,0,3,2.93l.77.68c.26.22.55.4.82.61.56.39,1.09.8,1.66,1.17l1.73,1L82,109l.45.21.9.41A29.54,29.54,0,0,0,87,111c.62.17,1.24.3,1.86.45l.91.21c.31.07.62.09.93.13l1.84.24c.61.06,1.22,0,1.82.07A26.1,26.1,0,0,0,97.9,112l.44,0,.43-.07.85-.15c.56-.11,1.13-.18,1.67-.31l1.62-.45.79-.22.77-.3,1.5-.58a5.17,5.17,0,0,0,.72-.33l.7-.35c.46-.24.93-.46,1.37-.7l1.28-.81a27.81,27.81,0,0,0,7.7-7.36l.68-.94.56-1,.55-.93c.09-.16.18-.3.26-.46l.21-.46q.44-.93.81-1.77c.25-.57.41-1.13.6-1.65.09-.27.18-.52.27-.77a5.4,5.4,0,0,0,.21-.73c.12-.48.22-.93.32-1.35s.2-.8.27-1.15.09-.69.13-1q.12-.86.18-1.32c0-.3.08-.45.08-.45s0,.15-.05.45-.09.75-.16,1.33c0,.29-.07.62-.12,1s-.16.74-.25,1.16-.2.87-.31,1.35a5.52,5.52,0,0,1-.21.74c-.09.25-.17.5-.26.77-.19.52-.35,1.09-.59,1.66l-.81,1.78-.21.47c-.08.16-.17.3-.26.46l-.54.94c-.18.32-.37.64-.57,1s-.44.63-.67,1a28,28,0,0,1-7.73,7.43l-1.28.81c-.44.25-.91.47-1.38.71l-.7.36a6,6,0,0,1-.73.33l-1.51.59c-.25.1-.5.21-.76.3l-.8.22-1.63.46c-.55.14-1.12.21-1.69.32l-.85.15-.44.07-.43,0a26.67,26.67,0,0,1-3.59.15c-.6,0-1.22,0-1.83-.07L90.66,112c-.31,0-.63-.07-.94-.13l-.92-.22c-.62-.15-1.25-.27-1.87-.45a29.48,29.48,0,0,1-3.66-1.38l-.91-.42c-.15-.07-.3-.13-.45-.21l-.44-.25-1.75-1c-.56-.36-1.1-.78-1.66-1.18a9.83,9.83,0,0,1-.83-.61l-.78-.68a32,32,0,0,1-3-3l-1.31-1.68-.33-.43-.29-.45L71,99l-.58-.92-.5-1-.49-1-.25-.49-.2-.51c-.26-.68-.53-1.37-.8-2.05L67.55,91a27.82,27.82,0,0,1,1.39-17.73c.31-.68.61-1.35.92-2L71,69.32c.1-.16.18-.32.28-.47l.32-.45.64-.88.64-.88.71-.82.71-.81.36-.4.39-.37,1.55-1.46A31.73,31.73,0,0,1,80,60.33l.88-.56c.29-.18.61-.32.91-.48.61-.3,1.21-.63,1.83-.9l1.89-.73.46-.19.48-.13,1-.27a29.14,29.14,0,0,1,3.84-.8c.64-.08,1.28-.11,1.91-.16l1-.07c.31,0,.63,0,.94,0l1.87,0c.61,0,1.22.15,1.82.21a26.73,26.73,0,0,1,3.52.7l.43.1.41.14.83.28c.54.2,1.09.36,1.61.58l1.54.7.75.35c.25.13.48.27.72.41l1.4.82a4.73,4.73,0,0,1,.66.44l.64.46c.42.31.85.6,1.25.91l1.14,1a27.74,27.74,0,0,1,6.48,8.54,26.23,26.23,0,0,1,2.48,7.71c.05.28.1.55.14.81a5.11,5.11,0,0,1,.1.76q0,.73.09,1.38c0,.43.07.82.07,1.19s0,.69,0,1c0,.58,0,1,0,1.34S122.87,86.38,122.87,86.38Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartMan);
export default __webpack_public_path__ + "static/media/cart_man.740edfa3117b5a481b6a76be16edeede.svg";
export { ForwardRef as ReactComponent };